module.exports = __webpack_public_path__ + "img/7.dbe106de.png";